import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearBasket,
  setBasketFromServer,
} from '../../../store/slices/basketSlice';
import { RootState } from '../../../store';
import { getStoredBasket, saveStoredBasket } from '../libs/basketStorage';

export const useClearBasket = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const basketItems = useSelector((state: RootState) => state.basket.items);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      productIds,
      cartKeys,
    }: {
      productIds?: number[];
      cartKeys?: string[];
    }) => {
      const currentBasket = basketItems.length ? basketItems : getStoredBasket();
      const nextBasket = cartKeys?.length
        ? currentBasket.filter(item => !cartKeys.includes(item.cartKey))
        : productIds?.length
          ? currentBasket.filter(item => !productIds.includes(item.id))
        : [];

      saveStoredBasket(nextBasket);

      if (cartKeys?.length || productIds?.length) {
        // Mirror exactly what was written to storage. Dispatching
        // `removeAllNotAvailableItems` instead dropped everything flagged
        // unavailable regardless of which keys were asked for, so a partial
        // removal left redux and storage disagreeing.
        dispatch(setBasketFromServer(nextBasket));
      } else {
        dispatch(clearBasket());
      }

      return { success: true };
    },
    onSuccess: () => {
      queryClient.setQueryData(['basket'], { basket: getStoredBasket() });
      queryClient.invalidateQueries({ queryKey: ['basket'] });
    },
  });
  return {
    clearBasket: mutateAsync,
    isPending,
  };
};
